var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProtectGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-protect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80,125.88c22.63,0,41-37.45,41-83.64C98.34,42.24,80,29,80,29",
    fill: "#666",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,29S61.66,42.24,39,42.24c0,46.19,18.34,83.64,41,83.64",
    fill: "#999",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.46,63.68l-2.63-2.13c-11.64-7.32-20.09,7.14-11.52,12.89L84,79.58c11.27,6.57,3.57,21.78-9.39,16.15l-5.63-3M80.14,105.3V96.95m0-45.72v8.32",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.94,
    y1: 36.67,
    x2: 108.17,
    y2: 14.27,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "6.01 1.5 3 1.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.01,
    y1: 36.67,
    x2: 131.59,
    y2: 1.63,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "6.01 1.5 3 1.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.81,
    y1: 40.32,
    x2: 137.5,
    y2: 32.03,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "6.01 1.5 3 1.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.02,
    y1: 46.56,
    x2: 141.72,
    y2: 65.74,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "6.01 1.5 3 1.5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectGoal);
export default __webpack_public_path__ + "static/media/protect-goal.2de7676b.svg";
export { ForwardRef as ReactComponent };